import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { CloseIcon } from '../../icons/Close';
import { Background, Container, HeaderContainer, CloseIconContainer, } from './styles';
export const Modal = ({ children, onExit }) => {
    const theme = useTheme();
    return (_jsx(Background, { onClick: () => onExit && onExit(), children: _jsxs(Container, { onClick: (e) => e.stopPropagation(), children: [onExit && (_jsx(HeaderContainer, { children: _jsx(CloseIconContainer, { onClick: () => onExit(), children: _jsx(CloseIcon, { color: theme.secondary }) }) })), _jsx("div", { children: children })] }) }));
};
